import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private readonly authService: AuthService,
    // private readonly toastService: ToastService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const clonedReq = req.clone({
      headers: req.headers
        .set("language", "en_US")
        // .set("language", navigator.language.replaceAll("-", "_"))
        .set("priceListCode", this.authService.store?.priceListCode || "")
    });

    return next.handle(clonedReq);
  }


}
